<div class="admin-input">
  <div class="search-input-container">
    <app-places-autocomplete (selectedGooglePlaceEmitter)="handleAddressChange($event)"></app-places-autocomplete>
  </div>
</div>
